"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("./Button"));
var _Paragraph = _interopRequireDefault(require("./Paragraph"));
var _Flex = _interopRequireDefault(require("./Flex"));
require("./UserOnHoldItem.scss");
var _Avatar = _interopRequireDefault(require("./Avatar"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var UserOnHoldItem = function UserOnHoldItem(_ref) {
  var fluid = _ref.fluid,
    user = _ref.user,
    onApprove = _ref.onApprove,
    onReject = _ref.onReject,
    onRemove = _ref.onRemove;
  var fluidClass = fluid ? "fluid" : "";
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    customClass: "UserOnHoldItem ".concat(fluidClass),
    gap: 300,
    align: "center",
    justify: "between"
  }, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    style: {
      gap: "var(--size-150)"
    },
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    avatar: user.avatar,
    role: user.role,
    altText: user.firstName,
    size: "medium"
  }), /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], null, user.firstName), /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], null, user.email)), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    align: "center",
    gap: 100,
    style: {
      marginLeft: "auto"
    }
  }, user.isApproved ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "small",
    variant: "danger",
    onClick: function onClick() {
      return onRemove(user);
    }
  }, "Remove User") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "small",
    variant: "solid",
    onClick: function onClick() {
      return onApprove(user);
    }
  }, "Approve"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "small",
    variant: "danger",
    onClick: function onClick() {
      return onReject(user);
    }
  }, "Reject"))));
};
var _default = exports["default"] = UserOnHoldItem;